<template>
  <v-tooltip :left="value.tooltipPosition === 'left'"
             :right="value.tooltipPosition === 'right'"
             :top="value.tooltipPosition === 'top'"
             :bottom="value.tooltipPosition === 'bottom'"
             :disabled="!value.tooltip && !value.tooltipPosition"
  >
    <template #activator="{ on }">
      <v-icon v-on="on">{{ value.value ? value.value : value }}</v-icon>
    </template>
    <span>{{ value.tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "IconCell",
  props: {
    value: {},
    item: {},
    header: {}
  }
}
</script>

<style scoped>

</style>
